module.exports = __webpack_public_path__ + "static/media/sell_make_9.7b420c0c.png";